import ManualFee from "@/models/Products/ProductFees/ManualFee";

export default class UpdateManualFeeRequest extends ManualFee {

    public constructor(fee: ManualFee) {
        super();
        if (fee) {
            this.id = fee.id;
            this.name = fee.name;
            this.subTransactionType = fee.subTransactionType;
            this.reference = fee.reference;
            this.amount.amount = fee.amount.amount;
            this.amount.currency = fee.amount.currency;
            this.amountOverridable = fee.amountOverridable;
        }
    }
}